import React from 'react';
import { Button, Tooltip } from 'antd';
import { buildLabel, isStageFull } from './buildConst';

// 阶段构建入口：根据资料完成度 + UI 确认 + 构建状态决定是否可点
// - 未构建：需该阶段资料 100%；一阶段还需 UI 设计已确认；二阶段需一阶段构建通过
// - 已构建/失败/构建中：可点查看
// variant：'link'（文本链接，列表用）/ 'button'（普通按钮，详情用）
const StageBuildAction = ({ stage, record, buildStates, onOpen, variant = 'link', uiConfirmed = true }) => {
    const st = buildStates[`${record.id}:${stage}`];
    const built = st === 'done' || st === 'failed' || st === 'building';
    const full = isStageFull(stage, record);
    const uiOk = stage !== 'phase1' || uiConfirmed;
    const prevOk = stage === 'phase1' || buildStates[`${record.id}:phase1`] === 'done';
    const canBuild = uiOk && prevOk;
    const enabled = built || (full && canBuild);

    let tip = '';
    if (!built && !full) tip = '资料未完成，暂不可构建';
    else if (stage === 'phase1' && !uiConfirmed) tip = '需客户确认UI设计通过后才能构建一阶段';
    else if (!built && !prevOk) tip = '需一阶段构建通过后才能构建二阶段';

    const btnProps = variant === 'button'
        ? { size: 'small', type: built ? 'default' : 'primary', danger: st === 'failed' }
        : { type: 'link', size: 'small', style: { padding: 0, height: 'auto' }, danger: st === 'failed' };

    const btn = (
        <Button {...btnProps} disabled={!enabled} onClick={() => onOpen(record, stage)}>
            {buildLabel(st, stage)}
        </Button>
    );
    return enabled ? btn : <Tooltip title={tip}><span>{btn}</span></Tooltip>;
};

export default StageBuildAction;
